import React, { useEffect, useRef } from "react";
import { Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, ListGroup, ListGroupItem } from "@/Components/ui";
;
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import toast, { Toaster } from 'react-hot-toast';
import { read, utils, writeFileXLSX, writeFile } from 'xlsx';
import ServerPaginatedTable from "../../../Components/Common/ServerPaginatedTable";
import { API_VOUCHERS, changeVoucherItem, deleteVoucherItem, getDataFromUrl } from "../../../api";
import moment from "moment";
import { dialogService } from "@/utils/dialogService";
const STATE_MODAL_FOCUS = {
    0: "사용처리",
    1: "사용취소",
};
const UserDetailVoucherList = ({ userPhoneNum }) => {
    const navigate = useNavigate();
    const tableName = "voucher";
    const columns = React.useMemo(() => [
        {
            Header: '번호',
            accessor: 'row_number',
            id: 'row_number',
        },
        {
            Header: 'ID',
            accessor: 'id',
            id: 'id',
        },
        {
            Header: '사용자',
            accessor: '사용자',
            id: 'user_id',
        },
        {
            Header: '교환권',
            accessor: '교환권',
            id: 'voucher',
        },
        {
            Header: '만료일',
            accessor: '만료일',
            id: 'used_time',
        },
        {
            Header: '상태',
            accessor: '상태',
            id: 'state',
        },
        {
            Header: 'Actions',
            accessor: 'Actions',
            id: '',
            Cell: (cellProps) => {
                return (<div className="d-flex gap-2">
                            {(cellProps.row.original["상태"] !== "사용함") && <div className="edit">
                                <div className="text" style={{ cursor: "pointer", color: "#3577f1" }} onClick={() => {
                            setCheckedRecords([cellProps.row.original]);
                            togStateChangeModal();
                            setFocusState(0);
                        }}>
                                    <i className="ri-pencil-fill fs-16"></i>
                                </div>
                            </div>}
                            {(cellProps.row.original["상태"] !== "사용안함") && <div className="edit">
                                <div className="text" style={{ cursor: "pointer", color: "#ffbe0b" }} onClick={() => {
                            setCheckedRecords([cellProps.row.original]);
                            togStateChangeModal();
                            setFocusState(1);
                        }}>
                                    <i className="ri-pencil-fill fs-16"></i>
                                </div>
                            </div>}
                            <div className="remove">
                                <div className="text-danger" style={{ cursor: "pointer" }} onClick={() => {
                        onClickDelete(cellProps.row.original.id);
                    }}>
                                    <i className="ri-delete-bin-5-fill fs-16"></i>
                                </div>
                            </div>
                        </div>);
            }
        },
    ], []);
    const [data, setData] = React.useState([]);
    const [previous, setPrevious] = React.useState("");
    const [next, setNext] = React.useState("");
    const [count, setCount] = React.useState("");
    const [dataQuery, setDataQuery] = React.useState({});
    const onRequestData = (_url) => {
        getDataFromUrl(_url)
            .then((data) => {
            setData(data.results);
            setPrevious(data.previous);
            setNext(data.next);
            setCount(data.count);
            // if (isSearch) calcTotalPageCount(data.count, (data.results).length);
        })
            .catch((e) => { console.log(e); });
    };
    React.useEffect(() => {
        if (!previous && !next) {
            getDataFromUrl(`${API_VOUCHERS}/?search=${userPhoneNum}`)
                .then((data) => {
                console.log("getDataFromUrl", data);
                setData(data.results);
                setPrevious(data.previous);
                setNext(data.next);
                setCount(data.count);
            })
                .catch((e) => { console.log(e); });
        }
    }, []);
    const [checkedRecords, setCheckedRecords] = React.useState([]);
    const [stateChangeModal, setStateChangeModal] = React.useState(false);
    const [focusState, setFocusState] = React.useState(-1); // 0 : "사용처리", 1 : "사용취소"
    const togStateChangeModal = () => setStateChangeModal(!stateChangeModal);
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [deleteModalMulti, setDeleteModalMulti] = React.useState(false);
    const checkedAll = () => {
        const checkall = document.getElementById(`checkBoxAll-${tableName}`);
        const ele = document.querySelectorAll(`.${tableName}.customerCheckBox`);
        if (checkall.checked) {
            ele.forEach((ele) => {
                ele.checked = true;
            });
        }
        else {
            ele.forEach((ele) => {
                ele.checked = false;
            });
        }
    };
    const clearSelectedOptions = () => {
        const ele = document.querySelectorAll(`.${tableName}.customerCheckBox:checked`);
        const checkall = document.getElementById(`checkBoxAll-${tableName}`);
        ele.forEach((element) => {
            element.checked = false;
        });
        if (checkall)
            checkall.checked = false;
    };
    const deleteRecords = async () => {
        const ele = document.querySelectorAll(`.${tableName}.customerCheckBox:checked`);
        const checkall = document.getElementById(`checkBoxAll-${tableName}`);
        if (ele.length === 0) {
            await dialogService.handleAlert("삭제할 항목이 없습니다.");
            return;
        }
        ele.forEach((element) => {
            console.log("reservation id:", element.value);
            deleteVoucherItem(element.value).then((data) => {
                console.log("deleteVoucherItem:", data);
            }).catch((e) => {
                console.warn(e);
            });
            element.checked = false;
        });
    };
    const onClickDelete = (order) => {
        setCheckedRecords([order]);
        setDeleteModal(true);
    };
    const handleDeleteOrder = () => {
        if (checkedRecords.length) {
            checkedRecords.forEach((value) => {
                console.log("reservation id:", value);
                deleteVoucherItem(value).then((data) => {
                    console.log("deleteVoucherItem:", data);
                }).catch((e) => {
                    console.warn(e);
                });
            });
            setDeleteModal(false);
        }
    };
    const changeState = () => {
        (async () => {
            if (focusState === 0) {
                // checkedRecords.forEach((record, idx, arr) => {
                for (let i = 0; i < checkedRecords.length; i++) {
                    const record = checkedRecords[i];
                    if (record["상태"] === "사용안함") {
                        await changeVoucherItem(record.id);
                    }
                }
                await dialogService.handleAlert("사용처리 완료");
            }
            else if (focusState === 1) {
                for (let i = 0; i < checkedRecords.length; i++) {
                    const record = checkedRecords[i];
                    if (record["상태"] === "사용함") {
                        await changeVoucherItem(record.id);
                    }
                }
                await dialogService.handleAlert("사용취소 완료");
            }
        })().then(() => history.go(0)).catch((e) => console.log(e));
    };
    return (<div>
            <DeleteModal show={deleteModal} onDeleteClick={handleDeleteOrder} onCloseClick={() => setDeleteModal(false)}/>
            <DeleteModal show={deleteModalMulti} onDeleteClick={() => {
            deleteRecords();
            setDeleteModalMulti(false);
        }} onCloseClick={() => setDeleteModalMulti(false)}/>
            {/* 교환권 상태 전환 Modal */}
            <Modal id="topmodal" isOpen={stateChangeModal} onClose={() => { clearSelectedOptions(); togStateChangeModal(); }}>
                <ModalHeader className="modal-title" id="myModalLabel" toggle={() => { clearSelectedOptions(); togStateChangeModal(); }}>
                    {STATE_MODAL_FOCUS[focusState]}
                </ModalHeader>
                <ModalBody className="text-center p-5">
                    <div className="mt-4">
                        <h6 className="mb-3">{`선택하신 사용자의 교환권을 모두 ${STATE_MODAL_FOCUS[focusState]}하시겠습니까?`}</h6>
                        <p className="text-muted mb-4">{(focusState === 0) ? '"사용안함"인 교환권만 "사용함"으로 변경됩니다.' : '"사용함"인 교환권만 "사용안함"으로 변경됩니다.'}</p>
                        {(checkedRecords.length > 0) ?
            <div className="live-preview" style={{ height: 200, overflowY: "scroll" }}>
                                    <ListGroup>
                                        {checkedRecords.map((record) => {
                    return (<ListGroupItem key={record.id} style={{ whiteSpace: "pre-line" }}>{`${record.id} - ${record["사용자"]} - ${record["교환권"]}`}</ListGroupItem>);
                })}
                                    </ListGroup>
                                </div> :
            <span>{`${STATE_MODAL_FOCUS[focusState]}할 사용자 교환권을 먼저 선택해주세요.`}</span>}
                        <br />
                        <br />
                        <div className="hstack gap-2 justify-content-center">
                            <button className={(focusState === 0) ? "btn btn-soft-secondary fw-medium" : "btn btn-soft-warning fw-medium"} onClick={() => { clearSelectedOptions(); togStateChangeModal(); }}><i className="ri-close-line me-1 align-middle"></i> Close</button>
                            <button className={(focusState === 0) ? "btn btn-secondary" : "btn btn-warning"} onClick={() => { changeState(); setStateChangeModal(false); }} disabled={checkedRecords.length === 0}>{STATE_MODAL_FOCUS[focusState]}</button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>

            <div>
                <React.Fragment>
                    <ServerPaginatedTable id="reservations-table" serachable={false} tableQuery={{ search: userPhoneNum }} url={API_VOUCHERS} columns={columns} data={data} previous={previous} next={next} count={count} onRequestData={onRequestData} onChangeQuery={setDataQuery} categories={[]}/>
                </React.Fragment>
            </div>
        </div>);
};
export default UserDetailVoucherList;
